export default __webpack_public_path__ + "static/media/bamboo-drivers.ac361175.jpg";